import axiosInstance from "services/AxiosInstance";

interface PropsPayload {
  userId: string;
  status: string;
}
export const accountStatusUpdate = async ({ userId, status }: PropsPayload) => {
  const payload = {
    status: status
  };
  const response = await axiosInstance.put(`/accounts/${userId}/status`, payload);
  return response.data;
};
